const VARIANT = import.meta.env.VITE_APP_WHICH === 'nyserda' ? 'nyserda' : 'portal';

const variant = () => VARIANT;

export default variant;
